import { render, staticRenderFns } from "./BudgetTextEditor.vue?vue&type=template&id=d79fc80a&"
import script from "./BudgetTextEditor.vue?vue&type=script&lang=js&"
export * from "./BudgetTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./BudgetTextEditor.vue?vue&type=style&index=0&id=d79fc80a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports